export const monthList = [
  { label: 'January', value: '1' },
  { label: 'February', value: '2' },
  { label: 'March', value: '3' },
  { label: 'April', value: '4' },
  { label: 'May', value: '5' },
  { label: 'June', value: '6' },
  { label: 'July', value: '7' },
  { label: 'August', value: '8' },
  { label: 'September', value: '9' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];

/**
 * Returns filtered month options based on the selected academic year name.
 *
 * Logic:
 * - If the selected academic year is a past year (end year < current year),
 *   return all 12 months.
 * - If it's the current academic year, return months up to and including
 *   the current month only.
 *
 * @param academicYearName - e.g. "2025-2026"
 * @returns Filtered month options
 */
export const getFilteredMonths = (
  academicYearName: string
): { label: string; value: string }[] => {
  const today = new Date();
  const currentMonth = today.getMonth() + 1; // 1-based
  const previousMonth = currentMonth - 1; // show months up to the previous month
  const currentYear = today.getFullYear() + 1;
  // Parse end year from academic year name (e.g. "2025-2026" → 2026)
  const parts = academicYearName.split('-');
  const endYear = parseInt(parts[1], 10);

  // Past academic year — show all months
  if (endYear < currentYear) {
    return [...monthList];
  }

  // Current academic year — show only up to the previous month
  if (endYear === currentYear || endYear === currentYear + 1) {
    return monthList.filter((m) => parseInt(m.value, 10) <= previousMonth);
  }

  // Future academic year — no months available yet
  return [];
};

// ── API response dropdown mapping helpers ────────────────────

export interface CategoryItem {
  id: string;
  category_name: string;
}

export interface ManagementItem {
  id: string;
  management: string;
}

export interface DesignationItem {
  id: string;
  stackholders: string;
}

export interface AdminDrpDwnsResult {
  cateList: CategoryItem[];
  managementList: ManagementItem[];
  veracityUtypes: DesignationItem[];
}

/**
 * Maps cateList from API response to dropdown options
 */
export const mapCategoryOptions = (
  cateList: CategoryItem[]
): { label: string; value: string }[] => {
  return cateList.map((item) => ({
    label: item.category_name,
    value: item.id,
  }));
};

/**
 * Maps managementList from API response to dropdown options
 */
export const mapManagementOptions = (
  managementList: ManagementItem[]
): { label: string; value: string }[] => {
  return managementList.map((item) => ({
    label: item.management,
    value: item.id,
  }));
};

/**
 * Maps veracityUtypes from API response to dropdown options (Designation)
 */
export const mapDesignationOptions = (
  veracityUtypes: DesignationItem[]
): { label: string; value: string }[] => {
  return veracityUtypes.map((item) => ({
    label: item.stackholders,
    value: item.id,
  }));
};
